import { Controller } from 'stimulus'
import { trackEvent } from '../../src/javascripts/tracking'

export default class extends Controller {

  static values = {theme: String}

  connect() {
  }

  openCustomQuestionsModal(e) {
    e.preventDefault()

    const event = new CustomEvent("open-addon-info-custom-questions-modal")
    window.dispatchEvent(event)

    trackEvent('Theme Filter: Open Custom Questions', {
      'themeName': e.target.parentElement.dataset.value
    });
  }

  openCustomBrandingModal(e) {
    e.preventDefault()

    const event = new CustomEvent("open-addon-info-custom-branding-modal")
    window.dispatchEvent(event)

    trackEvent('Theme Filter: Open Custom Branding', {
      'themeName': e.target.parentElement.dataset.value
    });
  }

  clickBookNow(e) {
    trackEvent('Theme Filter: Book Now', {
      'themeName': e.target.dataset.value
    });
  }

  clickMoreInfo(e) {
    trackEvent('Theme Filter: More Info', {
      'themeName': e.target.dataset.value
    });
  }
}
